import type { ErrorLike } from "@apollo/client";

export type GraphQLFormattedErrorLike = {
  message?: string;
  extensions?: { code?: string };
};

export type ApolloErrorLike = ErrorLike & {
  graphQLErrors?: GraphQLFormattedErrorLike[];
};

export function asApolloError(error: unknown): ApolloErrorLike | undefined {
  if (!error || typeof error !== "object") return undefined;
  return error as ApolloErrorLike;
}

export function graphQLErrorMessage(error: unknown, fallback: string): string {
  return asApolloError(error)?.graphQLErrors?.[0]?.message ?? fallback;
}

export function isGraphQLNotFound(error: unknown): boolean {
  return (
    asApolloError(error)?.graphQLErrors?.some(
      (entry) => entry.extensions?.code === "NOT_FOUND"
    ) ?? false
  );
}
